import { Chip } from "@mui/material";

interface Props {
  deliveredStatus: boolean;
  isBookAvailable: boolean;
}

export const MemoryBookStatusChip: React.FC<Props> = ({
  deliveredStatus,
  isBookAvailable,
}) => {
  const getStatusChipProps = (status: boolean | undefined) => {
    if (!isBookAvailable) {
      return {
        label: "Not available",
        bgcolor: "#eb354140",
        color: "#EB4335",
      };
    }
    switch (status) {
      case false:
        return {
          label: "In Progress",
          bgcolor: "#F79E1B40",
          color: "#F79E1B",
        };
      case true:
        return {
          label: "Confirmed",
          bgcolor: "#4BA66340",
          color: "#4BA663",
        };

      default:
        return {
          label: "Unknown",
          bgcolor: "#BDBDBD40",
          color: "#BDBDBD",
        };
    }
  };
  return (
    <Chip
      label={getStatusChipProps(deliveredStatus).label}
      sx={{
        bgcolor: getStatusChipProps(deliveredStatus).bgcolor,
        color: getStatusChipProps(deliveredStatus).color,
      }}
    />
  );
};
